if (document.querySelector(".mt-product-list__container") != null) {
  document.querySelectorAll(".mt-product-list__container").forEach((container) => {  
    var scrollBox = container.querySelector(".mt-product-list__items");
    var scrollBar = container.querySelector(".mt-product-list-progress");
    var thumb = container.querySelector('.mt-product-list-progress-bar');
    var leftBtn = container.querySelector(".mt-product-list-control.prev");
    var rightBtn = container.querySelector(".mt-product-list-control.next");
    var itemNodes = container.querySelectorAll('.mt-product-list__item');

    if (!scrollBox || !scrollBar || !thumb) return;

    // 第三版修改处

    // Equalize card__content heights within this container
    function equalizeCardContentHeights() {
      try {
        var cards = container.querySelectorAll('.mt-product-list__item .card__content');
        if (!cards || cards.length === 0) return;
        // reset heights to auto to measure natural heights
        cards.forEach(function(el){ el.style.minHeight = ''; el.style.height = 'auto'; });
        var max = 0;
        cards.forEach(function(el){ max = Math.max(max, el.offsetHeight); });
        if (max > 0) {
          cards.forEach(function(el){ el.style.minHeight = max + 'px'; });
        }
      } catch (err) {
        // no-op
      }
    }
    // 第三版修改处

    // 计算单卡片（含外边距）宽度与基于索引的滚动
    function getCardWidth() {
      if (!itemNodes || itemNodes.length === 0) return scrollBox.clientWidth;
      var first = itemNodes[0];
      var rect = first.getBoundingClientRect();
      var itemStyle = window.getComputedStyle(first);
      var marginLeft = parseFloat(itemStyle.marginLeft) || 0;
      var marginRight = parseFloat(itemStyle.marginRight) || 0;
      // 读取容器的列间距（flex-gap/grid-gap）
      var boxStyle = window.getComputedStyle(scrollBox);
      var columnGap = parseFloat(boxStyle.columnGap || boxStyle.gap || boxStyle.gridColumnGap) || 0;
      return rect.width + marginLeft + marginRight + columnGap;
    }

    // 起始偏移（容器左侧内边距），保证对齐到卡片起点
    function getStartOffset() {
      var boxStyle = window.getComputedStyle(scrollBox);
      return parseFloat(boxStyle.paddingLeft) || 0;
    }

    // 控制吸附取整方式：floor/ceil/round
    var ROUNDING_METHOD = 'floor';
    function snap(value) {
      if (ROUNDING_METHOD === 'floor') return Math.floor(value + 0.0001);
      if (ROUNDING_METHOD === 'ceil') return Math.ceil(value - 0.0001);
      return Math.round(value);
    }

    function getMaxIndex() {
      return Math.max(0, (itemNodes ? itemNodes.length - 1 : 0));
    }

    function getCurrentIndex() {
      let cw = getCardWidth();
      if (!cw) return 0;
      let index = snap((scrollBox.scrollLeft + 20) / cw);
      if(index < 0){
        return 0;
      }else{
        return index;
      }
      
    }

    function scrollToIndex(index, smooth) {
      var cw = getCardWidth();
      //var start = getStartOffset();
      var targetIndex = Math.max(0, Math.min(index, getMaxIndex()));
      scrollBox.scrollTo({ left: targetIndex * cw, behavior: smooth === false ? 'auto' : 'smooth' });
    }

  function updateThumb() {
      var visibleWidth = scrollBox.clientWidth;
      var totalWidth = scrollBox.scrollWidth;
      var scrollLeft = scrollBox.scrollLeft;

      // 内容不溢出时，thumb 占满
      if (totalWidth <= visibleWidth) {
        thumb.style.width = "100%";
        thumb.style.left = "0%";
        thumb.style.display = "block";
        return;
      }
      var thumbWidth = Math.max((visibleWidth / totalWidth) * 100, 10); // 最小10%
      var thumbLeft = (scrollLeft / totalWidth) * 100;
      thumb.style.width = thumbWidth + "%";
      thumb.style.left = (isNaN(thumbLeft) ? 0 : thumbLeft) + "%";
      thumb.style.display = "block";
    }

      // 滚动条点击事件
    scrollBar.addEventListener('click', function(e) {
      // 如果点击的是thumb，不处理
      if (e.target === thumb) return;
      
      var rect = scrollBar.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var scrollBarWidth = rect.width;
      var percent = clickX / scrollBarWidth;
      
      // 计算可滚动的最大距离
      var maxScroll = scrollBox.scrollWidth - scrollBox.clientWidth;
      var targetScrollLeft = percent * maxScroll;
      
      scrollBox.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    });

    // 拖动thumb控制内容滚动（移动端 touch）
    let isDragging = false;
    let startX = 0;
    let startLeft = 0;
    let scrollBarWidth = 0;
    let scrollBoxWidth = 0;
    let maxPercent = 0;


    thumb.addEventListener(
      "touchstart",
      function (e) {
        isDragging = true;
        startX = e.touches[0].clientX;
        scrollBarWidth = scrollBar.offsetWidth;
        scrollBoxWidth = scrollBox.scrollWidth;
        maxPercent = (scrollBar.offsetWidth - thumb.offsetWidth) * 100 / scrollBar.offsetWidth;
        startLeft = parseFloat(thumb.style.left) || 0;

        document.body.style.userSelect = "none";
        e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener(
      "touchmove",
      function (e) {
        if (!isDragging) return;
        let deltaX = e.touches[0].clientX - startX;
        var newLeftPx = (startLeft / 100) * scrollBarWidth + deltaX;
        var percent = newLeftPx / scrollBarWidth;
        var scrollTo = percent * scrollBoxWidth;
        console.log("scrollTo: " + scrollTo + ",deltaX: " + deltaX + ",left: " + percent);

        percent = percent * 100;
        scrollBox.scrollLeft = scrollTo;
        if(percent > maxPercent){
          percent = maxPercent;
        }
        if(percent < 0){
          percent = 0;
        }
        thumb.style.left = percent + "%";
        e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener("touchend", function () {
      if (isDragging) {
        isDragging = false;
        document.body.style.userSelect = "";
      }
    });

    // 拖动thumb控制内容滚动（PC）
    thumb.addEventListener("mousedown", function (e) {
        isDragging = true;
        startX = e.clientX;
        scrollBarWidth = scrollBar.offsetWidth;
        scrollBoxWidth = scrollBox.scrollWidth;
        startLeft = parseFloat(thumb.style.left) || 0;
        maxPercent = (scrollBar.offsetWidth - thumb.offsetWidth) * 100 / scrollBar.offsetWidth;

        document.body.style.userSelect = "none";
    });

    document.addEventListener("mousemove", function (e) {
      if (!isDragging) return;
        let deltaX = e.clientX - startX;
        var newLeftPx = (startLeft / 100) * scrollBarWidth + deltaX;
        var percent = newLeftPx / scrollBarWidth;
        var scrollTo = percent * scrollBoxWidth;
        console.log("scrollTo: " + scrollTo + ",deltaX: " + deltaX + ",left: " + percent);

        percent = percent * 100;
        scrollBox.scrollLeft = scrollTo;
        if(percent > maxPercent){
          percent = maxPercent;
        }
        if(percent < 0){
          percent = 0;
        }
        thumb.style.left = percent + "%";
    });

    document.addEventListener("mouseup", function () {
      if (isDragging) {
        isDragging = false;
        document.body.style.userSelect = "";
      }
    });


    let isBoxDragging = false;
    let startBoxX = 0;
    // 拖动thumb控制内容滚动（PC）
    scrollBox.addEventListener("mousedown", function (e) {
        isBoxDragging = true;
        startBoxX = e.clientX;
        document.body.style.userSelect = "none";
        e.preventDefault();
    });

    document.addEventListener("mousemove", function (e) {
      if (!isBoxDragging) return;
        let deltaX = e.clientX - startBoxX;
        console.log("clientX: " + e.clientX );
        scrollBox.scrollLeft = scrollBox.scrollLeft - deltaX ;
        startBoxX = e.clientX;
        e.preventDefault();
    });

    document.addEventListener("mouseup", function () {
        isBoxDragging = false;
        document.body.style.userSelect = "";
    });

    // 按钮滚动
    function getScrollStep() {
      return getCardWidth();
    }
    if (leftBtn) {
      leftBtn.addEventListener('click', function() {
        var nextIndex = getCurrentIndex() - 1;
        scrollToIndex(nextIndex, true);
      });
    }
    if (rightBtn) {
      rightBtn.addEventListener('click', function() {
        var nextIndex = getCurrentIndex() + 1;
        scrollToIndex(nextIndex, true);
      });
    }
    

    // 监听内容滚动，实时同步thumb
    scrollBox.addEventListener('scroll', updateThumb);

    // 初始化和窗口变化
    // 第三版修改处
    updateThumb();
    equalizeCardContentHeights();
    window.addEventListener('resize', function(){
      updateThumb();
      equalizeCardContentHeights();
    });

    // Observe each item's content changes to re-equalize when rich text wraps/loads
    var resizeObserver;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function(){
        equalizeCardContentHeights();
      });
      container.querySelectorAll('.mt-product-list__item .card__content').forEach(function(el){
        resizeObserver.observe(el);
      });
    } else {
      // fallback polling
      setInterval(equalizeCardContentHeights, 500);
    }
    
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mt-product-card-wrapper .card').forEach(function(card) {
    card.addEventListener('click', function(e) {
      if (e.target.closest('a')) return;
      var url = card.getAttribute('data-url');
      if (url) window.location.href = url;
    });
  });
});
